const BidHandler = require('./bidderHandler');

const perfDisableByCfgId = {};

const BidUtils = {
	getViewPort() {
		return {
			vWidth: window.innerWidth,
			vHeight: window.innerHeight,
		};
	},

	isDimensionValid({ dimension, viewport }) {
		const {
			minWidth, maxWidth, minHeight, maxHeight,
		} = dimension;
		const { vWidth, vHeight } = viewport;
		return (!minWidth || vWidth >= minWidth)
			&& (!maxWidth || vWidth < maxWidth)
			&& (!minHeight || vHeight >= minHeight)
			&& (!maxHeight || vHeight < maxHeight);
	},

	shouldPerfDisable({ performanceDisabledBidders, configId, data }, { bidder }, geoCountry, randNum) {
		let disable = (perfDisableByCfgId[configId] = perfDisableByCfgId[configId] || {})[bidder];
		if (disable !== undefined) {
			return disable;
		}
		const shouldSample = () => randNum < data.rlvLowPerfSample;
		const { performanceDisabled, performanceDisabledByCountry } = performanceDisabledBidders[bidder] || {};
		if (performanceDisabled && !shouldSample()) {
			disable = true;
		} else if (performanceDisabledByCountry) {
			const disabled = performanceDisabledByCountry[geoCountry || '[Unknown]'] ?? performanceDisabledByCountry.other;
			if (disabled && !shouldSample()) {
				disable = true;
			}
		}
		return (perfDisableByCfgId[configId][bidder] = disable ?? false);
	},

	filterBids(params) {
		const { bids, validDimensions, auction } = params;
		if (!validDimensions.length) {
			return [];
		}
		const { geoCountry } = window.relevantDigital.getInstance();
		// Use same random number for entire auction so we don't end up having bid responses with
		// many different combinations of SSPs, which would lead to poor use of CompressedPageViews
		const randNum = Math.random() * 100;
		return bids.filter((bid) => {
			const handler = BidHandler.of(bid);
			if (BidUtils.shouldPerfDisable(auction, bid, geoCountry, randNum)) {
				return false;
			}
			// skip geo filtering and geo-based performance filtering if geoCountry is not available
			if (!geoCountry) {
				return !handler.isInvalid(bid, params);
			}
			const { filterType, countries } = auction.data.rlvBySsp?.[handler.id] || {};
			if (filterType && countries && countries.includes(geoCountry) !== (filterType === 'include')) {
				return false;
			}
			return !handler.isInvalid(bid, params);
		});
	},
};

module.exports = BidUtils;
